var React = require('react');

function Wave (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#0090dd","fillOpacity":"1","d":"M0,192L60,176C120,160,240,128,360,122.7C480,117,600,139,720,128C840,117,960,75,1080,64C1200,53,1320,75,1380,85.3L1440,96L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"}));
}

Wave.defaultProps = {"viewBox":"0 0 1440 320"};

module.exports = Wave;

Wave.default = Wave;
